// extracted by mini-css-extract-plugin
export default {"container":"w_YG913sg3b1g1HjkzT3","heading":"_v2qsrraiukY41qomOhg"};